module.exports = __webpack_public_path__ + "img/arrendamiento01.7f1f4d85.png";